import { render, staticRenderFns } from "./AddUserType.vue?vue&type=template&id=610a93b1&scoped=true"
import script from "./AddUserType.vue?vue&type=script&lang=js"
export * from "./AddUserType.vue?vue&type=script&lang=js"
import style0 from "./AddUserType.vue?vue&type=style&index=0&id=610a93b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a93b1",
  null
  
)

export default component.exports